<template>
  <div id="getRewardedModal" class="modal fade modal-flex" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content reward-modal reward-modal-small">
        <div class="modal-body">
          <h4 class="title">{{ $t('claim_success') }}</h4>

          <AppIcon :src="$store.state.treasure_icon_url" :size="150" />

          <div class="gem">
            <span id="congratulation_gem">{{ reward }}</span>
          </div>

          <button class="btn btn-ito-2-large" data-bs-dismiss="modal" aria-label="Close">OK</button>
        </div>

        <i class="ito-icon-close modal-close" data-bs-dismiss="modal" aria-label="Close"></i>
      </div>
    </div>
  </div>
</template>

<script>
import AppIcon from "@/components/common/AppIcon.vue";

export default {
  name: "GetRewardModal",
  props: ['reward'],
  components: { AppIcon },
  methods: {

    ok() {
      location.reload();
    }

  }
}
</script>

<style scoped></style>